
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/git-for-kids",
      function () {
        return require("private-next-pages/courses/git-for-kids.tsx");
      }
    ]);
  